import { render } from "./ProgettiMenu.vue?vue&type=template&id=faa9b9de&ts=true"
import script from "./ProgettiMenu.vue?vue&type=script&lang=ts"
export * from "./ProgettiMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__